import { Link as LinkMagik, Pagination, createTable } from "@inmagik/magik-ui"
import { FiltersBase, GruppoDiRicerca } from "../../types"
import { useMemo } from "react"
import { PAGE_SIZE } from "../../constants"
import { Link } from "react-router-dom"

const Table = createTable<GruppoDiRicerca>()

export function TableGruppiDiRicerca({
  gruppiDiRicerca,
  setFilters,
  filters,
  count,
  fullCount,
}: {
  gruppiDiRicerca: GruppoDiRicerca[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
}) {
  const numPages = useMemo(() => {
    if (!gruppiDiRicerca) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [gruppiDiRicerca, count])

  return (
    <Table
      data={gruppiDiRicerca}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />
      <Table.Column
        title="Nome"
        name="nome"
        sortable
        stickyLeft
        width="minmax(max-content, 1fr)"
        render={(gruppoDiRicerca) => (
          <Link to={`/gruppi-di-ricerca/gruppi-di-ricerca/${gruppoDiRicerca.id}`}>
            <LinkMagik className="text-dark">{gruppoDiRicerca.nome}</LinkMagik>
          </Link>
        )}
      />
      <Table.Column
        title="Immagine"
        name="immagine"
        sortable
        width="minmax(max-content, 1fr)"
        render={(immagine) => <img src={immagine.immagine} alt={immagine.nome} style={{ width: 100 }} />}
      />
      
      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} persone del gruppo di ricerca.
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>
    </Table>
  )
}
